import { TableModule } from 'primeng/table';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { OverlayPanelModule} from 'primeng/overlaypanel';
import { CalendarModule} from 'primeng/calendar';
@NgModule({
  imports: [
    FormsModule,
    TableModule,
    MultiSelectModule,
    OverlayPanelModule,
    CalendarModule
  ],
  exports: [
    FormsModule,
    TableModule,
    MultiSelectModule,
    OverlayPanelModule,
    CalendarModule
  ],
  declarations: []
})
export class PrimeModule {}

